var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.form.editing === _vm.field.uuid)?_c('a',{staticClass:"design-tag delete",on:{"click":_vm.onDrop}},[_c('SvgIcon',{attrs:{"name":"trash-alt"}}),_c('span',[_vm._v("删除")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }